module.exports = {
    NODE_ENV: 'development',
    // API_URL: 'https://localhost:44362/api/v1',
    //API_URL: 'https://csdldp-sdc-api.vnptdongthap.com.vn/api/v1',
    API_URL: 'https://csdldp-sdc-api.vnptdongthap.com.vn/api/v1',
    API_URL_V2: 'https://csdldp-sdc-api.vnptdongthap.com.vn/api/v2',
    LOGIN_URL: 'https://ioc-sdc-administration-api.vnptdongthap.com.vn/api/v1',
    LOGIN_PAGE: 'https://ioc.sadec.dongthap.gov.vn/',
    QUYHOACH_PAGE: 'https://quyhoach.sadec.dongthap.gov.vn/',
    APPID: 'a9612ed4-555d-431e-b4cf-2db3726e3f84',
    CURRENT_PAGE: 1,
    DEFAULT_LIMIT: 10,
    PAGE_OPTION: [{ id: 10, name: "Hiển thị trên cổng 10 dòng", value: 10, text: "Hiển thị trên cổng 10 dòng" }, { id: 30, name: "Hiển thị trên cổng 30 dòng", value: 30, text: "Hiển thị trên cổng 30 dòng" }, { id: 50, name: "Hiển thị trên cổng 50 dòng", value: 50, text: "Hiển thị trên cổng 50 dòng" }],
    TINHTP_SITEID : "87",
    TINHTP_SITENAME: "Đồng Tháp",
    QUANHUYEN_SITEID: "867",
    QUANHUYEN_SITENAME: "TP Sa Đéc",
    PHUONGXA_SITEID : "",


}